export const GET_IMAP_ACCOUNTS = 'GET_IMAP_ACCOUNTS';